import React, { ReactNode } from "react";
import Spin from "components/spin/spin";
import classNames from "classnames";
import "./websiteBuilderLoadingContent.scss";

interface IWebsiteBuilderLoadingContentProps {
  loading: boolean;
  children: ReactNode;
}

export function WebsiteBuilderLoadingContent(props: IWebsiteBuilderLoadingContentProps) {
  const { loading, children } = props;

  return (
    <div
      className={classNames("website-builder-loading-content-container", {
        "spin": loading,
        "children": !loading,
      })}
    >
      {loading ? <Spin /> : children}
    </div>
  );
}